import { Grid } from "@mui/material";
import CreateOrgModal from "./CreateOrgModal";
import DeleteOrgModal from "./DeleteOrgModal";
import EditOrgModal from "./EditOrgModal";
import HeadersOrgTable from "./HeadersOrgTable";
import { OrganizationsTable } from "./OrganizationsTable";

const OrganizationPanel = () => {
  return (
    <>
      {/* Search bar y crear org */}
      <Grid item>
        <HeadersOrgTable />
      </Grid>

      {/* Tabla de organizaciones */}
      <Grid item>
        <OrganizationsTable />
      </Grid>

      {/* Modal para crear organizacion */}
      <Grid item>
        <CreateOrgModal />
      </Grid>

      {/* Modal para editar organizacion */}
      <Grid item>
        <EditOrgModal />
      </Grid>

      {/* Modal para borrar organizacion */}
      <Grid item>
        <DeleteOrgModal />
      </Grid>
    </>
  );
};

export default OrganizationPanel;
